import { useCallback, useState } from "react";
import MapLayerSelector from "../components/LayerSelector/MapLayerSelector";
import { MapLayerSelectedContext } from "./hooks/MapLayerSelectionContext";

const MapLayerSelectedProvider = MapLayerSelectedContext.Provider;

export default function MapLayerSelectionContainer({ children }) {
  const [selectedLayer, setSelectedLayer] = useState("default");

  const handleSelect = useCallback((data) => {
    setSelectedLayer(data);
  }, []);

  return (
    <MapLayerSelector onSelect={handleSelect} selected={selectedLayer}>
      <MapLayerSelectedProvider value={selectedLayer}>
        {children}
      </MapLayerSelectedProvider>
    </MapLayerSelector>
  );
}
